import React, { useRef } from 'react';
import Slider from 'react-slick';
import FooterCopyrightVersion from '../common/footer/FooterCopyrightVersion';
import useScreenWidth from '../common/hooks/useScreenWidth';
import { withTranslation } from 'react-i18next';
import { Typography } from "../ecosystem/";

const LoginCarousel = ({
    t,
    mobile,
    tablet,
    desktop
}) => {

    const sliderRef = useRef();
    const screenWidth = useScreenWidth();
    const isPortraitImage = (desktop && screenWidth < 1920) ? true : false;

    const slides =
        [
            {
                id: 0,
                body: 'Make appointments on your schedule.',
                heading: 'Scheduling',
                img: isPortraitImage ? 'images/carousel-scheduling.png' : 'images/carousel-scheduling-xl.png',
            },
            {
                id: 1,
                body: 'View lab results and past visit summaries.',
                heading: 'Test results',
                img: isPortraitImage ? 'images/carousel-test-result.png' : 'images/carousel-test-result-xl.png',
            },
            {
                id: 2,
                body: "Securely communicate with your care team.",
                heading: "Messaging my doc",
                img: isPortraitImage ? 'images/carousel-message-provider.png' : 'images/carousel-message-provider-xl.png',
            },
            {
                id: 3,
                body: 'Talk to a doctor from anywhere.',
                heading: 'Video visits',
                img: isPortraitImage ? 'images/carousel-video-visit.png' : 'images/carousel-video-visit-xl.png',
            },
            {
                id: 4,
                body: 'Manage the family’s healthcare needs from one place.',
                heading: 'My family’s health',
                img: isPortraitImage ? 'images/carousel-family-health.png' : 'images/carousel-family-health-xl.png',
            },
        ];

    const renderSlides = () =>
        slides.map(slide => (
            <div className='login-carousel-slide' key={slide.id}>
                <div className='login-carousel-slide__content' style={{ backgroundImage: `url(${slide.img})` }}>
                    <div className='login-carousel-slide__gradient'></div>
                    <div className='login-carousel-slide__text'>
                        <div className='login-carousel-slide__text-heading'>
                            <Typography type={mobile ? "heading-06" : tablet ? "heading-07" : "heading-08"} color={'$color-primary-c1'} responsive>{slide.heading}</Typography>
                            <Typography type={mobile ? "heading-06" : tablet ? "heading-07" : "heading-08"} color={'$color-primary-c1'} tag="div" responsive>{"My Way"}</Typography>
                        </div>
                        <div className='login-carousel-slide__text-body'>
                            <Typography type={mobile ? "body-2" : tablet ? "heading-03" : "heading-05"} color={'$color-primary-c1'} responsive>{slide.body}</Typography>
                        </div>
                        {(tablet || desktop) && <FooterCopyrightVersion typographyType="meta-02" typographyColor="$color-primary-c1" />}
                    </div>
                </div>
            </div>
        ));

    return (
        <Slider ref={sliderRef}
            dots={true}
            autoplay={true}
            autoplaySpeed={3000}
            pauseOnHover={true}
            pauseOnFocus={true}
            arrows={false}
        >
            {renderSlides()}
        </Slider>
    );
}

export default withTranslation()(LoginCarousel);
